import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What is the Awakened Artist Academy, really?",
    a: "A quiet space for creative people who feel a little dormant. Right now, it begins with a small free guide, and over time, occasional letters from the studio. Honest, slow, never noisy. The rest is still unfolding, and I'll share more when it's ready.",
  },
  {
    q: "Who is this for?",
    a: "Artists, writers, makers, and quietly creative people. People who can feel the work waiting, but haven't quite found their way back to it. No prior practice, no portfolio, no permission required. If you're reading this, you're invited.",
  },
  {
    q: "Why is the first step so small?",
    a: "Because small is what survives a real life. The reawakening isn't built on willpower or heroic mornings. It's built on something gentle enough that you'll still be doing it three weeks from now. The first doorway is intentionally easy to walk through.",
  },
  {
    q: "Is there a paid program?",
    a: "Not yet. For now, the focus is the free guide. What unfolds beyond it is still being shaped. When something more is ready, you'll be the first to know, and there will be no pressure either way.",
  },
  {
    q: "How do I unsubscribe?",
    a: "One click at the bottom of any email. I won't ask why, and you won't have to click through anything. This is a quiet practice, not a marketing funnel.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-[#F7F5F2] border-b border-[#E5E0D8]"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-4" data-reveal>
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#1FA5B8] font-body">
              Quiet questions
            </div>
            <h2 className="mt-4 font-display text-[#1A1A1A] leading-[1.02] tracking-tight text-[clamp(2.25rem,4.4vw,3.5rem)] font-medium">
              Before you{" "}
              <span className="italic font-light">begin</span>.
            </h2>
            <p className="mt-6 font-body text-[#5C5C5C] leading-relaxed">
              If something else is on your mind, reply to any email. A real
              person reads them.
            </p>
          </div>

          <div className="col-span-12 md:col-span-7 md:col-start-6" data-reveal>
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i + 1}`}
                  className="border-b border-[#E5E0D8]"
                >
                  <AccordionTrigger className="font-display text-left text-[22px] md:text-[26px] tracking-tight text-[#1A1A1A] hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="font-body text-[#5C5C5C] text-base leading-relaxed pb-8 pr-8">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
